import React, { createContext, useContext, useState, useCallback } from "react";
import { translations } from "@/lib/content";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("en");
  const toggle = useCallback((l) => setLang(l), []);
  const t = translations[lang];
  return (
    <LanguageContext.Provider value={{ lang, setLang: toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
